import theme from '../../../../../lib/theme';
import { ValuePropositionsBlockProps } from './ValuePropositionsBlock';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

//  this is a v2 block so will remove all vertical surrounding padding
export default ({}: ValuePropositionsBlockProps) => ({
  headingContainer: {
    ...layouts.spacedColumn('xs'),

    width: '100%',
  },
});